import React, { useState, useEffect } from 'react';
import { MiniCadCardsRow } from '../../pages/relatorio/styles';
import CardCountMetric from '../CardCountMetric';
import api from '../../services/api';

const CadastrosResumo = ({ dtInicial, dtFinal, ...props }) => {
    const [totalProdutores, setTotalProdutores] = useState(null);
    const [totalFazendas, setTotalFazendas] = useState(null);
    const [trendProdutores, setTrendProdutores] = useState(null);
    const [trendFazendas, setTrendFazendas] = useState(null);

    const searchInitialData = async () => {
        setTotalProdutores(null);
        setTotalFazendas(null);

        try {
            const params = { dtInicial, dtFinal };
            const [responseProdutores, responseFazendas] = await Promise.all([
                api.get('/relatorio/metrica-produtores', { params }),
                api.get('/relatorio/metrica-fazendas', { params }),
            ]);

            setTotalProdutores(responseProdutores.data.data.total);
            setTrendProdutores(responseProdutores.data.data.percentage ?? null);

            setTotalFazendas(responseFazendas.data.data.total);
            setTrendFazendas(responseFazendas.data.data.percentage ?? null);
        } catch (error) {
            setTotalProdutores(0);
            setTotalFazendas(0);
        }
    }

    useEffect(() => {
        searchInitialData();
    }, [dtInicial, dtFinal])

    return (
        <MiniCadCardsRow>
            <CardCountMetric
                title="Produtores cadastrados"
                value={totalProdutores}
                loading={totalProdutores === null}
                trendPercent={trendProdutores}
                isNew={trendProdutores === null && totalProdutores > 0}
            />

            <CardCountMetric
                title="Fazendas cadastradas"
                value={totalFazendas}
                loading={totalFazendas === null}
                trendPercent={trendFazendas}
                isNew={trendFazendas === null && totalFazendas > 0}
            />
        </MiniCadCardsRow>
    )
}

export default CadastrosResumo;
